import { render, staticRenderFns } from "./AddBundleProductModal.vue?vue&type=template&id=5bf1cf08&"
import script from "./AddBundleProductModal.vue?vue&type=script&lang=js&"
export * from "./AddBundleProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports